module.exports = __webpack_public_path__ + "static/media/home.3187bc82.svg";